<template> 
  <div> 
    <div class="d-flex flex-stack flex-wrap">
        <div class="page-title d-flex flex-column me-3 mt-3"> 
            <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('update_user_group') }}</h1>
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                    </a>
                </li> 
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">{{ $t('settings') }}</router-link></li>
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'UserManagement' }">{{ $t('user_management') }}</router-link></li>
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'UserGroupList' }">{{ $t('user_groups') }}</router-link></li> 
              <li class="breadcrumb-item text-gray-600">{{ $t('update_user_groups') }}</li> 
              <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
            </ul> 
        </div>  
      <div class="d-flex align-items-center py-1">
        <router-link to="/UserGroupList">
            <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                  <span class="ms-2 fs-7"> {{ $t('return_back_to_list') }} </span>
            </button>
        </router-link>
        &nbsp;
        <div class="dropdown">
            <button class="btn btn-light-info border border-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="true" id="userGroupActions" type="button">
            <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
            <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
            </svg></span>
                {{ $t('actions') }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="userGroupActions"> 
                <li>
                    <a class="dropdown-item fs-4 text-danger" href="#" @click="deleteItem()"><span class="svg-icon svg-icon-muted svg-icon-2 text-danger"><svg width="24" height="24" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"/>
                    <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"/>
                    <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"/>
                    </svg>
                    </span>{{ $t('delete') }} </a>
                </li>
            </ul>
        </div>  
      </div>  
    </div>
    <div class="content flex-row-fluid mt-6" id="kt_content">
      <RequiredField></RequiredField>
      <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
        <li class="nav-item">
            <a class="nav-link" :class="{'active': this.activeTab == 'UserGroup'}" data-bs-toggle="tab" href="#kt_user_group_tab_0" target="_self"
            @click="this.activeTab = 'UserGroup'">
                <h4 class="text-gray-800"> {{ $t('user_group') }} </h4>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" :class="{'active': this.activeTab == 'Credentials'}" data-bs-toggle="tab" href="#kt_user_group_tab_1" target="_self"
            @click="this.activeTab = 'Credentials', getCredentials()">
                <h4 class="text-gray-800"> {{ $t('credentials') }} </h4>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" :class="{'active': this.activeTab == 'Users'}" data-bs-toggle="tab" href="#kt_user_group_tab_2" target="_self"
            @click="this.activeTab = 'Users', getUsers()">
                <h4 class="text-gray-800"> {{ $t('users') }} </h4>
            </a>
        </li>
      </ul>
      
      <div class="tab-content" id="myTabContent">
        <div class="card card-xxl-stretch tab-pane fade show active" id="kt_user_group_tab_0" role="tabpanel" v-if="this.activeTab == 'UserGroup'">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 mt-0"> 
                <div class="d-flex flex-row row">
                  <div class="d-flex flex-column flex-row-auto col-lg-12"> 
                    <div class="d-flex flex-column-fluid card card-xxl-stretch mb-xxl-6 bg-lighten border border-gray-300">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-lg-12">
                            <label class="fs-6 fw-bold form-label mt-3 required">
                              {{ $t('group_name') }}
                            </label>
                            <input type="text" class="form-control" name="name" v-model="form.name"> 
                          </div>
                          <div class="col-lg-12">
                            <label class="fs-6 fw-bold form-label mt-3">
                              {{ $t('description') }}
                            </label>
                            <textarea rows="3" class="form-control " name="description" v-model="form.description"></textarea>
                          </div>
                          <div class="col-lg-12">
                            <label class="fs-6 fw-bold form-label mt-3" for="isActive">
                              {{ $t('is_active') }}
                            </label>
                            <div class="form-check mt-3 mb-3">
                              <input class="form-check-input" type="checkbox" value="" id="isActive" v-model="form.is_active">
                            </div> 
                          </div>
                        </div>
                      </div> 
                    </div>
                  </div> 
                </div>
              </div>
              <div class="col-lg-12">
                <div class="d-grid gap-2"> 
                  <button type="button" class="btn btn-lg btn-primary " @click="this.saveData()" data-kt-indicator="on">
                    <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                    <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                    </svg>
                    </span>
                    <strong v-if="!this.isProgressing"> {{ $t('save_user_groups') }} </strong> 
                    <span class="indicator-progress" v-if="this.isProgressing">
                        {{ $t('saving_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span> 
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-xxl-stretch tab-pane fade show active" id="kt_user_group_tab_1" role="tabpanel" v-if="this.activeTab == 'Credentials'">
          <div class="card-body">
            <DxTreeList
              id="credentials"
              :data-source="credentialTreeList"
              :show-borders="true"
              :column-auto-width="true"
              :word-wrap-enabled="true"
              :auto-expand-all="true"
              :expanded-row-keys="[1,2,3,4,5,6,7,8]"
              key-expr="id"
              items-expr="items"
              parent-id-expr="parent_id">

              <DxSearchPanel :visible="true" :width="250" />
              <DxHeaderFilter :visible="true"/>
              <DxColumn caption="Credential Name" data-field="name" header-cell-template="name-header" cell-template="name-cell-template"/>
              <DxColumn caption="View?" data-field="view_crd" alignment="center" header-cell-template="view_crd-header" cell-template="view_crd-cell-template" />
              <DxColumn caption="Read?" data-field="read_crd" alignment="center" header-cell-template="read_crd-header" cell-template="read_crd-cell-template" />
              <DxColumn caption="Insert?" data-field="insert_crd" alignment="center" header-cell-template="insert_crd-header" cell-template="insert_crd-cell-template" />
              <DxColumn caption="Update?" data-field="update_crd" alignment="center" header-cell-template="update_crd-header" cell-template="update_crd-cell-template" />
              <DxColumn caption="Delete?" data-field="delete_crd" alignment="center" header-cell-template="delete_crd-header" cell-template="delete_crd-cell-template" />
              <DxColumn caption="Print?" data-field="print_crd" alignment="center" header-cell-template="print_crd-header" cell-template="print_crd-cell-template" />
              <DxColumn caption="Company Inquiry?" data-field="company_inquiry_crd" alignment="center" header-cell-template="company_inquiry_crd-header" cell-template="company_inquiry_crd-cell-template" />
              <DxColumn caption="Address Inquiry?" data-field="address_inquiry_crd" alignment="center" header-cell-template="address_inquiry_crd-header" cell-template="address_inquiry_crd-cell-template" />
              <DxColumn caption="Change Lock Update Status?" data-field="change_update_lock_crd" alignment="center" header-cell-template="change_update_lock_crd-header" cell-template="change_update_lock_crd-cell-template" />
              <DxColumn caption="Update Locked Record?" data-field="update_locked_record_crd" alignment="center" header-cell-template="update_locked_record_crd-header" cell-template="update_locked_record_crd-cell-template" />

              
              <!-- Header Cell Templates -->
              <template #name-header>
                <div class="text-gray-800 fs-7">{{ $t('credential_name') }}</div>
              </template>
              <template #view_crd-header>
                <label class="form-label">{{ $t('view') }}</label>
                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                  <input class="form-check-input" type="checkbox" v-model="this.credentialHeader.view_crd" @change="onChangeAllCredentials('view_crd')">
                </div>
              </template>
              <template #read_crd-header>
                <label class="form-label">{{ $t('read') }}</label>
                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                  <input class="form-check-input" type="checkbox" v-model="this.credentialHeader.read_crd" @change="onChangeAllCredentials('read_crd')">
                </div>
              </template>
              <template #insert_crd-header>
                <label class="form-label">{{ $t('insert') }}</label>
                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                  <input class="form-check-input" type="checkbox" v-model="this.credentialHeader.insert_crd" @change="onChangeAllCredentials('insert_crd')">
                </div>
              </template>
              <template #update_crd-header>
                <label class="form-label">{{ $t('update') }}</label>
                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                  <input class="form-check-input" type="checkbox" v-model="this.credentialHeader.update_crd" @change="onChangeAllCredentials('update_crd')">
                </div>
              </template>
              <template #delete_crd-header>
                <label class="form-label">{{ $t('delete') }}</label>
                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                  <input class="form-check-input" type="checkbox" v-model="this.credentialHeader.delete_crd" @change="onChangeAllCredentials('delete_crd')">
                </div>
              </template>
              <template #print_crd-header>
                <label class="form-label">{{ $t('print') }}</label>
                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                  <input class="form-check-input" type="checkbox" v-model="this.credentialHeader.print_crd" @change="onChangeAllCredentials('print_crd')">
                </div>
              </template>
              <template #company_inquiry_crd-header>
                <label class="form-label">{{ $t('company_inquiry') }}</label>
                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                  <input class="form-check-input" type="checkbox" v-model="this.credentialHeader.company_inquiry_crd" @change="onChangeAllCredentials('company_inquiry_crd')">
                </div>
              </template>
              <template #address_inquiry_crd-header>
                <label class="form-label">{{ $t('address_inquiry') }}</label>
                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                  <input class="form-check-input" type="checkbox" v-model="this.credentialHeader.address_inquiry_crd" @change="onChangeAllCredentials('address_inquiry_crd')">
                </div>
              </template>
              <template #change_update_lock_crd-header>
                <label class="form-label">{{ $t('change_lock_update_status') }}</label>
                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                  <input class="form-check-input" type="checkbox" v-model="this.credentialHeader.change_update_lock_crd" @change="onChangeAllCredentials('change_update_lock_crd')">
                </div>
              </template>
              <template #update_locked_record_crd-header>
                <label class="form-label">{{ $t('update_locked_record') }}</label>
                <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                  <input class="form-check-input" type="checkbox" v-model="this.credentialHeader.update_locked_record_crd" @change="onChangeAllCredentials('update_locked_record_crd')">
                </div>
              </template>

              <!-- Cell Templates -->
              <template #name-cell-template="{ data }"> 
                <span>
                  {{$t(data.data.name)}}
                </span>
              </template>
              <template #read_crd-cell-template="{ data }"> 
                <span>
                  <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                    <input class="form-check-input" type="checkbox" v-model="data.data.read_crd" @change="onChangeCredential('read_crd', data.data)" />
                  </div>
                </span>
              </template>
              <template #view_crd-cell-template="{ data }"> 
                <span>
                  <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                    <input class="form-check-input" type="checkbox" v-model="data.data.view_crd" @change="onChangeCredential('view_crd', data.data)" />
                  </div>
                </span>
              </template>
              <template #insert_crd-cell-template="{ data }"> 
                <span>
                  <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                    <input class="form-check-input" type="checkbox" v-model="data.data.insert_crd" @change="onChangeCredential('insert_crd', data.data)" />
                  </div>
                </span>
              </template>
              <template #update_crd-cell-template="{ data }"> 
                <span>
                  <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                    <input class="form-check-input" type="checkbox" v-model="data.data.update_crd" @change="onChangeCredential('update_crd', data.data)" />
                  </div>
                </span>
              </template>
              <template #delete_crd-cell-template="{ data }"> 
                <span>
                  <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                    <input class="form-check-input" type="checkbox" v-model="data.data.delete_crd" @change="onChangeCredential('delete_crd', data.data)" />
                  </div>
                </span>
              </template>
              <template #print_crd-cell-template="{ data }"> 
                <span>
                  <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                    <input class="form-check-input" type="checkbox" v-model="data.data.print_crd" @change="onChangeCredential('print_crd', data.data)" />
                  </div>
                </span>
              </template>
              <template #company_inquiry_crd-cell-template="{ data }"> 
                <span>
                  <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                    <input class="form-check-input" type="checkbox" v-model="data.data.company_inquiry_crd" @change="onChangeCredential('company_inquiry_crd', data.data)" />
                  </div>
                </span>
              </template>
              <template #address_inquiry_crd-cell-template="{ data }"> 
                <span>
                  <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                    <input class="form-check-input" type="checkbox" v-model="data.data.address_inquiry_crd" @change="onChangeCredential('address_inquiry_crd', data.data)" />
                  </div>
                </span>
              </template>
              <template #change_update_lock_crd-cell-template="{ data }"> 
                <span>
                  <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                    <input class="form-check-input" type="checkbox" v-model="data.data.change_update_lock_crd" @change="onChangeCredential('change_update_lock_crd', data.data)" />
                  </div>
                </span>
              </template>
              <template #update_locked_record_crd-cell-template="{ data }"> 
                <span>
                  <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                    <input class="form-check-input" type="checkbox" v-model="data.data.update_locked_record_crd" @change="onChangeCredential('update_locked_record_crd', data.data)" />
                  </div>
                </span>
              </template>
            </DxTreeList>
          </div>
          <div class="card-footer p-3">
            <div class="row">
              <div class="col-lg-12">
                <div class="d-grid gap-2"> 
                  <button type="button" class="btn btn-lg btn-primary " @click="this.saveCredentials()" data-kt-indicator="on">
                    <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                    <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                    </svg>
                    </span>
                    <strong v-if="!this.isProgressing"> {{ $t('save_credentials') }} </strong> 
                    <span class="indicator-progress" v-if="this.isProgressing">
                        {{ $t('saving_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span> 
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-xxl-stretch tab-pane fade show active" id="kt_user_group_tab_2" role="tabpanel" v-if="this.activeTab == 'Users'">
          <div class="card-header">
              <div class="card-title">
                  {{ $t('add_user_to_group') }}
              </div>
          </div>
          <div class="card-body"> 
              <form id="group_user_form" @submit.prevent="" class="form fv-plugins-bootstrap5 fv-plugins-framework">  
                  <div class="fv-row mb-6 row">   
                      <div class="col-lg-4">
                          <div class="fv-row">
                              <label class="fs-6 fw-bold form-label mt-3">
                                  {{ $t('user') }}
                              </label> 
                              <Select2 v-model="user_id" :options="userList" :settings="{width: '100%'}"/> 
                          </div>
                      </div>
                  </div> 
              </form>
              <div class="separator my-10"></div>
              <div class="d-flex flex-stack flex-wrap my-5">
                  <div class="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
                      <button type="button" class="btn btn-sm btn-light btn-active-success me-3" @click="addUser()">
                          <span class="svg-icon svg-icon-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                  viewBox="0 0 24 24" fill="none">
                                  <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1"
                                      transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                  <rect x="4.36396" y="11.364" width="16" height="2" rx="1"
                                      fill="currentColor">
                                  </rect>
                              </svg>
                          </span>
                          {{ $t('add') }}
                      </button>
                      <button type="button" class="btn btn-sm btn-light btn-active-warning me-3" @click="deleteUser()" 
                          :disabled="isButtonDisabled == null || isButtonDisabled == undefined">
                          <span class="svg-icon svg-icon-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                              </svg>
                          </span>
                          {{ $t('remove') }}
                      </button>
                      <button type="button" class="btn btn-sm btn btn-light btn-active-danger me-3" @click="deleteAllUsers()" :disabled="this.groupUserList.length == 0">
                          <span class="svg-icon svg-icon-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                              </svg>
                          </span>
                          {{ $t('remove_all') }}
                      </button>
                  </div>
              </div>
              <div id="kt_datatable_example_1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                <div class="table-responsive">
                  <DxDataGrid id="gridContainer"
                    :key="$i18n.locale"
                    :show-borders="true" 
                    key-expr="user_id" 
                    :data-source="groupUserList" 
                    :allow-column-reordering="true"  
                    :allow-column-resizing="true" 
                    :column-auto-width="true" 
                    :row-alternatin-enabled="true"
                    :hover-state-enabled="true" 
                    :show-row-lines="true" 
                    @exporting="this.$onExporting($event , 'User-Group-List')">

                    <DxFilterRow :visible="true"/>
                    <DxHeaderFilter :visible="true"/>
                    <DxGroupPanel :visible="true"/>      
                    <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx','pdf']" :allow-export-selected-data="false"/>
                    <DxPaging :page-size="10000"/>
                    <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true"/> 
                    <DxSearchPanel :visible="true"/>
                    <DxScrolling
                      mode="virtual"
                      row-rendering-mode="virtual"
                    />
                    <DxColumn data-field="isSelected" caption="#" :width="100" :allow-filtering="false" alignment="center" cell-template="is-selected-cell-template"/>
                    <DxColumn data-field="user_name" :caption="$t('name')" cell-template="user_name-cell-template" /> 
                    <DxColumn data-field="user_mail" :caption="$t('email')" cell-template="user_mail-cell-template" />

                    <template #is-selected-cell-template="{ data }"> 
                      <span>
                        <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                          <input class="form-check-input" type="checkbox" v-model="data.data.isSelected" @change="this.onSelectItem(data.data)" />
                        </div>
                      </span>
                    </template>
                    <template #user_name-cell-template="{ data }"> 
                      <span>
                        {{ data.data.user_name }}
                      </span>
                    </template>
                    <template #user_mail-cell-template="{ data }"> 
                      <span>
                        {{ data.data.user_mail }}
                      </span>
                    </template>
                </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import axios from 'axios'; 
import { DxTreeList } from 'devextreme-vue/tree-list';
import { DxDataGrid, DxColumn, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxSearchPanel, DxScrolling } from 'devextreme-vue/data-grid';
export default {
  name: "UserGroupUpdate",  
  components:{ 
    DxTreeList, DxColumn, DxHeaderFilter, DxSearchPanel, DxDataGrid, DxFilterRow, DxGroupPanel, DxExport, DxPaging, DxPager, DxScrolling 
  },
  data() {
    return {
      menuSelection: '/UserGroupHelppage',
      iconView : false,
      form: {
        id: null,
        name: null,
        description: null,
        is_active: false
      },
      credentialHeader: {
        view_crd: false,
        read_crd: false,
        insert_crd: false,
        update_crd: false,
        delete_crd: false,
        print_crd: false,
        company_inquiry_crd: false,
        address_inquiry_crd: false,
        change_update_lock_crd: false,
        update_locked_record_crd: false
      },
      user_id: '-1',
      credentialList: [],
      userList: [],
      groupUserList: [],
      activeTab: 'UserGroup',
      selectedUserId: null
    };
  },
  computed: {
    credentialTreeList() {
      return this.credentialList.map((i) => {
        if (i.id === i.parent_id) { i.items = i; }
        return i;
      });
    },
    isButtonDisabled() {
      return this.groupUserList.find(item => item.isSelected == true && item.id !== '' );
    },
  },
  methods: {
    getData() {
      this.$setSessionStorage('refreshList', true);
      const parameters = {
        session_id : this.$getUser().session_id,
        id: this.$getSessionStorage("record_id"),
        user_group_id: this.$getSessionStorage("record_id")
      };    
      axios.post('/api/UserGroup/GetById', parameters, {'Content-Type': 'application/json'})
      .then((response) => {
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          this.form = response.data.user_group;
          this.groupUserList = response.data.users; 
        }
      })
      .catch((error) => {
         console.error(error);
      });
    },
    getCredentials() {
      const parameters = {
        session_id: this.$getUser().session_id,
        user_group_id: this.$getSessionStorage("record_id")
      };  
      axios.post('/api/UserGroup/Credentials', parameters, {'Content-Type': 'application/json'})
      .then((response) => {
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          this.credentialList = response.data;
        }
      })
      .catch((error) => {
         console.error(error);
      });
    },
    getUsers() {
      const parameters = {
        session_id : this.$getUser().session_id
      }; 
      axios.post('/api/Users/CompanyUsers', parameters, {'Content-Type': 'application/json'})
      .then((response) => {
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          this.userList = response.data; 
          this.userList.forEach(element => {
            element.user_mail = this.$unlock(element.user_mail);
            element.name_surname = this.$unlock(element.name_surname);
            element.text = this.$unlock(element.text);
            element.phone = this.$unlock(element.phone);
            element.user_description = this.$unlock(element.user_description);
          });
          this.userList.unshift({ id: '-1', text: this.$t('select_an_option')});
        }
      })
      .catch((error) => {
         console.error(error);
      });
    },
    saveData() {
      const parameters = {
        session_id : this.$getUser().session_id,
        id: this.$getSessionStorage("record_id"),
        name: this.form.name,
        description: this.form.description,
        is_active: this.form.is_active ? 1 : 0
      };  
      axios.post('/api/UserGroup/UpdateGroup', parameters, {'Content-Type': 'application/json'})
      .then((response) => {
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');
          this.$setSessionStorage('refreshList', true); 
        }
      })
      .catch((error) => {
          console.error(error);
      });
    },
    saveLogs() {
      const parameters = {
        log_type: 3,
        log_location: 175,
        session_id: this.$getUser().session_id,
        log_location_detail: '',
        log_operation: 8,
        document_no: '',
        account_id: '',
        description: 'The credentials of the ' + this.form.name + ' updated.',
      };  
      axios.post('/api/GetCompanyAccounts/SaveLogs', parameters, {'Content-Type': 'application/json'});
    },
    saveCredentials() {
      this.$swal.fire({
        title: this.$t('are_you_sure_you_want_to_save_this_operation'),
        confirmButtonColor: "#50cd89",
        showDenyButton: false,
        showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
        confirmButtonText: this.$t('save'),
        icon: 'info'
      })
      .then((result) => {
        if (result.isConfirmed) {
          const credentialsToSave = [];
          this.credentialList.forEach(element => {
            // if(!element.has_sub_credential) {
              credentialsToSave.push({
                id: element.id,
                view_crd: element.view_crd,
                read_crd: element.read_crd,
                insert_crd: element.insert_crd,
                update_crd: element.update_crd,
                delete_crd: element.delete_crd,
                print_crd: element.print_crd,
                company_inquiry_crd: element.company_inquiry_crd,
                address_inquiry_crd: element.address_inquiry_crd,
                change_update_lock_crd: element.change_update_lock_crd,
                update_locked_record_crd: element.update_locked_record_crd,
              })
            // }
          });

          const parameters = {
            session_id: this.$getUser().session_id,
            user_group_id: this.$getSessionStorage("record_id"),
            credentials: credentialsToSave
          };  
          axios.post('/api/UserGroup/UpdateCredentials', parameters, {'Content-Type': 'application/json'})
          .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
              this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');
              this.saveLogs();
              this.getCredentials();
            }
          })
          .catch((error) => {
            console.error(error);
          });
        }
      });
    },
    deleteItem() { 
      this.$swal.fire({
        title: this.$t('are_you_sure_you_want_to_delete_this_data'),
        confirmButtonColor: '#f1416c',
        showDenyButton: false,
        showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
        confirmButtonText: this.$t('yes'),
        icon: 'warning'
      }).then((result) => { 
        if (result.isConfirmed) {
        const queryParameter = {
          session_id: this.$getUser().session_id,
          id: this.$getSessionStorage("record_id")
        };
        axios.post('/api/UserGroup/DeleteGroup', queryParameter, {'Content-Type': 'application/json'})
          .then((response) => { 
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
              this.$setSessionStorage('refreshList', true);
              this.$router.push({ name: 'UserGroupList' });
            }
          })
          .catch((error) => {
            console.error(error);
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");
          });
        }
      })  
    },
    onChangeCredential(credentialName, data) {
      let parentIds = [];
      if(data.has_sub_credential) {
        this.credentialList.forEach(element => {
          if(element.parent_id == data.id) {
            element[credentialName] = data[credentialName];
            if(element.has_sub_credential) parentIds.push(element.id);
          }
          //Parent menu secildiginde buna baglı 2.seviye sub menuler de isaretleniyor
          parentIds.forEach(x => {
            if(x == element.parent_id) { element[credentialName] = data[credentialName]; }
          });
        });
      }
    },
    onChangeAllCredentials(credentialName) {      
      this.credentialList.forEach(element => {
        element[credentialName] = this.credentialHeader[credentialName];
      });
    },
    addUser(){
      if (this.user_id == '-1' || this.user_id == '' || this.user_id == null || this.user_id == undefined) {
        this.$swal(this.$t('failed'), this.$t('user_must_be_selected'), 'warning' );
        return;
      }
      const parameters = {
        session_id: this.$getUser().session_id,
        user_id: this.user_id,
        user_group_id: this.$getSessionStorage("record_id")
      };
      axios.post('/api/UserGroup/AddUser', parameters, {'Content-Type': 'application/json'})
      .then((response) => {
        if(response.data.error == null || response.data.error == '' || response.data.error == undefined){
          axios.post('/api/UserGroup/GetGroupUsers', parameters, {'Content-Type': 'application/json'})
           .then((response) => {
              this.groupUserList = response.data;
              this.user_id = '-1';
              this.selectedUserId = null; 
            })
        }
      }) 
      .catch((error) => {
        console.error(error);
      });
    },
    deleteUser(){
      this.$swal.fire({
        title: this.$t('are_you_sure_you_want_to_remove_this_item'),
        confirmButtonColor: "#f1416c",
        showDenyButton: false,
        showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
        confirmButtonText: this.$t('delete'),
        icon: 'info'
      })
      .then((result) => {
        if (result.isConfirmed) {
          const parameters = {
            session_id: this.$getUser().session_id,
            user_id: this.selectedUserId,
            user_group_id: this.$getSessionStorage("record_id"),
            is_delete_all: 0
          }; 
          axios.post('/api/UserGroup/DeleteUser', parameters, {'Content-Type': 'application/json'})
          .then((response) => {
            this.groupUserList = response.data;
            this.selectedUserId = null;
          }) 
          .catch((error) => {
              console.error(error);
          });
        }
      });
    },
    deleteAllUsers(){ 
      this.$swal.fire({
        title: this.$t('are_you_sure_you_want_to_remove_all_items'),
        confirmButtonColor: "#f1416c",
        showDenyButton: false,
        showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
        confirmButtonText: this.$t('delete'),
        icon: 'info'
      })
      .then((result) => {
        if (result.isConfirmed) { 
          const parameters = {
            session_id: this.$getUser().session_id,
            user_group_id: this.$getSessionStorage("record_id"),
            is_delete_all: 1,
            user_id: null
          }; 
          axios.post('/api/UserGroup/DeleteUser', parameters, {'Content-Type': 'application/json'})
          .then((response) => {
            this.groupUserList = response.data;
            this.selectedUserId = null;
          }) 
          .catch((error) => {
            console.error(error);
          });
        }
      });
    },
    onSelectItem(item) { 
      this.selectedUserId = item.user_id;
      this.groupUserList.forEach((value) => {
        if (item.id !== value.id) { 
          value.isSelected = false;
        }
      });
    },
    async helpPageViewIcon()
    {
      const queryparameter = {
        session_id : this.$getUser().session_id,
        menu_selection : '/UserGroupHelppage'
      };
      axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
      .then((response) => { 
        if(!response.data.error){ 
          this.iconView = response.data;
        }
      })
    }
  },
  mounted() { 
    this.getData();
    this.helpPageViewIcon();
  }
}; 
</script>